// TODO: SV - See what is common and keep it here and get Dash to also use this (for now it is duplicated).

// externals
import type { Middleware } from 'redux';
import { createStore, applyMiddleware, compose } from 'redux';
import { connectRouter } from 'connected-react-router';

// utils
import historyInstance from './historyInstance';
import { reducerRegistry } from './reducerRegistry';
import { scopeMiddleware } from '@makemydeal/shared-scoped-store';
import type { ScopeCreationFactory } from '@makemydeal/shared-scoped-store';

export interface IPreloadedState {}

export function configureStore(
    preloadedState: IPreloadedState,
    initialMiddleware: Middleware<any, any, any>[],
    initialGlobalReducers: any,
    initialScopedReducers?: any,
    isScoped = false,
    scopeCreationFactory?: ScopeCreationFactory,
    telemetryMiddleware: Middleware<any, any, any>[] = []
) {
    reducerRegistry.reset();
    reducerRegistry.registerGlobal('router', connectRouter(historyInstance));
    reducerRegistry.registerMultipleGlobal(initialGlobalReducers);

    if (initialScopedReducers) {
        reducerRegistry.registerMultipleScoped(initialScopedReducers);
    }

    if (isScoped) {
        reducerRegistry.setScoped();
    }

    if (scopeCreationFactory) {
        reducerRegistry.setScopeCreationFactory(scopeCreationFactory);
    }

    const allReducers = reducerRegistry.getReducers();
    const businessAndTelemetry = [...initialMiddleware, ...telemetryMiddleware];
    const middlewares = isScoped ? businessAndTelemetry.map((m) => scopeMiddleware(m)) : businessAndTelemetry;
    const store = createStore(allReducers, preloadedState, compose(applyMiddleware(...middlewares)));

    reducerRegistry.setChangeListener((reducers) => {
        store.replaceReducer(reducers);
    });

    return store;
}
